var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Space-Rocket-Earth--Streamline-Ultimate",
    clipPath: "url(#clip0_32745_18488)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.8834 30.3364C5.9895 27.7019 4.16822 24.0932 3.76784 20.2002C3.36745 16.3073 4.41606 12.4034 6.71314 9.235C9.01022 6.06661 12.3946 3.85611 16.219 3.02618C20.0435 2.19626 24.0397 2.80515 27.4434 4.73644",
    stroke: "#101820",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.30326 30.2231C1.28159 33.7648 0.604925 36.5131 1.74659 37.6565C3.47992 39.3881 8.90326 36.9398 15.1833 31.9598",
    stroke: "#101820",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M22.3717 30.7015L16.405 24.7349L29.6667 11.4732C30.7484 10.392 32.1041 9.6257 33.5884 9.25654L37 8.39988C37.2355 8.3412 37.4822 8.34446 37.7161 8.40935C37.95 8.47423 38.1631 8.59853 38.3347 8.77016C38.5064 8.94178 38.6307 9.1549 38.6956 9.38878C38.7604 9.62267 38.7637 9.86936 38.705 10.1049L37.8517 13.5182C37.4809 15.002 36.7135 16.3571 35.6317 17.4382L22.3717 30.7015Z",
    stroke: "#101820",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.4051 24.7349L11.5184 23.1066C11.4043 23.0689 11.3017 23.0025 11.2205 22.9138C11.1393 22.8252 11.0822 22.7172 11.0546 22.6002C11.0271 22.4832 11.0299 22.361 11.063 22.2454C11.096 22.1298 11.1582 22.0247 11.2434 21.9399L12.9468 20.2366C13.6872 19.4962 14.6193 18.9767 15.6384 18.7362C16.6575 18.4957 17.7234 18.5437 18.7168 18.8749L21.3834 19.7616L16.4051 24.7349Z",
    stroke: "#101820",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M22.3716 30.7015L23.9999 35.5899C24.0377 35.704 24.104 35.8066 24.1927 35.8878C24.2813 35.969 24.3893 36.0261 24.5063 36.0536C24.6233 36.0812 24.7455 36.0784 24.8611 36.0453C24.9767 36.0123 25.0818 35.9501 25.1666 35.8649L26.8699 34.1615C27.6103 33.421 28.1298 32.489 28.3703 31.4699C28.6108 30.4508 28.5628 29.3849 28.2316 28.3915L27.3449 25.7249L22.3716 30.7015Z",
    stroke: "#101820",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32745_18488"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.589844)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.4b76d5bb9ed57edafb317505b1ea0665.svg";
export { ForwardRef as ReactComponent };